// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__967Yp","container":"styles_container__Tj1XB","title":"styles_title__2r0Nt","wrapper":"styles_wrapper__2uuAj","answer":"styles_answer__3HfC3"};